import { useEffect, useState } from 'react';

import { useModal } from 'context/ModalContext';

import { ConfirmacaoDaAcao } from './moldura-da-acao';

interface Props {
  callback: (obj: { id: string; message?: string }) => void;
  id: string;
  status: string | undefined;
  data?: any;
}

export default function ModalDouble(props: Props) {
  const modalID = 'validation-double';

  const { openModal, closeModal } = useModal();
  const { callback, id } = props;

  const [modalIsOpen, setIsOpen] = useState<boolean>(false);

  useEffect(() => {
    if (typeof id === 'string' && typeof openModal === 'string' && openModal === `${modalID}-${id}`) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [id, openModal]);

  if (!modalIsOpen) return <></>;

  return (
    <ConfirmacaoDaAcao
      title="Bonificar realização"
      onClose={() => closeModal()}
      onConfirm={() => {
        callback({ id: 'double' });
        closeModal();
      }}
    >
      <p className="m-0">Você pode bonificar as entregas validadas. Deseja confirmar essa ação?</p>
    </ConfirmacaoDaAcao>
  );
}
